module.exports = __webpack_public_path__ + "img/about-banner.0245667d.png";